<template>
    <div>
        <b-container class="bv-example-row">
            <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col>
                    <b-link class="text-success float-right" v-if="can('manage', 'supervisors') && !is_deleted" @click="showModal">
                        <h1>+</h1>
                    </b-link>
                </b-col>
            </b-row>
            <b-table v-if="supervisors.length>0" striped hover :items="supervisors" :fields="columns">
                <template #cell(names)="data">
                    {{ data.item.names }}
                </template>
                <template #cell(delete)="data">
                    <b-link class="text-danger float-center" v-if="can('manage', 'supervisors') && !is_deleted" @click="deleted(data.item)">
                        <h2>x</h2>
                    </b-link>
                </template>
            </b-table>
        </b-container>
        <div>
            <b-modal ref="addSupervisor" hide-footer title="Agregar Supervisor">
            <div class="d-block text-center">
                  <resource-filter @input="addSupervisor($event.id)"></resource-filter>
            </div>
            <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Cancelar</b-btn>
            </b-modal>
        </div>
    </div>
</template>
<script>
import {can} from '../../utils'
import ResourceFilter from '../ResourceFilter.vue'
import {mapActions} from 'vuex'
export default {
    data: function(){
        return {
            results: [],
            objSupervisor:{'id':'','name':''},
            columns:[
                {key:'names',label:"Nombre"},
                {key:'delete',label:'Borrar'}
            ]
        }
    },
    mounted(){
        
    },
    props:{
        employee: Object
    },
    components:{
        ResourceFilter
    },
    methods:{
        ...mapActions(['getAndShowEmployee','displayError']),
        can: can,
        showModal () {
            var app = this;
            var params = {quickSearch: this.objSupervisor.name}
            
            this.$refs.addSupervisor.show()
        },
        hideModal () {
            this.$refs.addSupervisor.hide()
        },
        deleted(supervisor){
            axios.delete('/supervisors/'+supervisor.id,{params:{'employee_id':this.employee.id}})
            .then(res=>{
                this.getAndShowEmployee(this.employee.id)
            })
            .catch(res=> {
                this.displayError(["No se pudo eliminar el supervisor"]);
            })
        },
        addSupervisor(id){
            axios.put('/supervisors/'+this.employee.id,{'id':id})
            .then(resp=>{
                this.getAndShowEmployee(this.employee.id)
                this.hideModal()
            })
            .catch(resp=>{
                this.displayError(["No se pudo agregar el supervisor"])
            })

        }
    },
    computed:{
        supervisors(){
            return this.employee.supervisors || []
        },
        is_deleted() {
            return this.employee.deleted_at !== null;
        }
    }
}
</script>
